// src/services/resourceParser.ts
import {
    ChapterResourcesResponse,
    IntroductionDomain,
    McqClusterDomain,
    OneMarkClusterDomain,
    LongQuestionDomain
} from "../models/ChapterResourcesDomain";

export const parseChapterResources = (json: any): ChapterResourcesResponse => {
    if (!json) return createEmptyResponse();

    return {
        // STRICT PARSING for Introduction
        introduction: parseIntroduction(json.introduction),

        mcq: Array.isArray(json.mcq) ? json.mcq.map(parseMcqCluster) : [],
        oneMark: Array.isArray(json.oneMark) ? json.oneMark.map(parseOneMarkCluster) : [],
        twoMarks: Array.isArray(json.twoMarks) ? json.twoMarks.map(parseLongQuestion) : [],
        threeMarks: Array.isArray(json.threeMarks) ? json.threeMarks.map(parseLongQuestion) : [],
        fourMarks: Array.isArray(json.fourMarks) ? json.fourMarks.map(parseLongQuestion) : [],
        fiveMarks: Array.isArray(json.fiveMarks) ? json.fiveMarks.map(parseLongQuestion) : [],
    };
};

const createEmptyResponse = (): ChapterResourcesResponse => ({
    introduction: null,
    mcq: [],
    oneMark: [],
    twoMarks: [],
    threeMarks: [],
    fourMarks: [],
    fiveMarks: []
});

const parseIntroduction = (data: any): IntroductionDomain | null => {
    // 1. Safety Check: If data is missing, return null
    if (!data) return null;

    // 2. DEFENSIVE GUARD: If this object has 'mcqGroups', it is definitely NOT an introduction.
    if (data.mcqGroups && Array.isArray(data.mcqGroups)) {
        console.warn("Parser: Detected MCQ object inside Introduction field. Ignoring.");
        return null;
    }

    // REMOVED: The check that blocked titles containing 'MCQ' has been removed.
    // This was causing valid introduction videos to be ignored.

    // 3. Must have URL or VideoID
    if (!data.url && !data.videoId) return null;

    return {
        videoId: data.videoId,
        title: data.title || "Introduction",
        url: data.url,
        description: data.description,
        question: data.question,
        mimeType: data.mimeType,
        displayOrder: data.displayOrder
    };
};

const parseMcqCluster = (data: any): McqClusterDomain => ({
    videoId: data.videoId,
    title: data.title || "MCQ Video",
    url: data.url || "",
    description: data.description,
    displayOrder: data.displayOrder,
    mcqGroups: Array.isArray(data.mcqGroups) ? data.mcqGroups : []
});

const parseOneMarkCluster = (data: any): OneMarkClusterDomain => ({
    videoId: data.videoId,
    title: data.title || "1 Mark Video",
    url: data.url || "",
    description: data.description,
    questions: Array.isArray(data.questions) ? data.questions : []
});

const parseLongQuestion = (data: any): LongQuestionDomain => ({
    id: data.id,
    questionNumber: data.questionNumber,
    question: data.question,
    description: data.description,
    questionImageUrl: data.questionImageUrl,
    marks: data.marks,
    resources: Array.isArray(data.resources) ? data.resources : []
});